'use client'

import Link from 'next/link'
import Image from 'next/image'
import { useState } from 'react'
import logo from '../assets/crypto-street-logo.svg'

const socials = [
  {
    name: 'X',
    href: 'https://x.com/crypto__st',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.253 5.622 5.91-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>,
  },
  {
    name: 'Telegram',
    href: 'https://t.me/s/Crypto_Street',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8l-1.7 8.02c-.12.58-.46.72-.93.45l-2.58-1.9-1.24 1.19c-.14.14-.25.25-.51.25l.18-2.6 4.74-4.28c.21-.18-.04-.28-.32-.1L7.46 15.4l-2.52-.79c-.55-.17-.56-.55.11-.81l9.86-3.8c.46-.17.86.11.73.8z"/></svg>,
  },
  {
    name: 'YouTube',
    href: 'https://www.youtube.com/@crypto-st',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>,
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/crypto_street__',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/></svg>,
  },
  {
    name: 'TikTok',
    href: 'https://www.tiktok.com/@crypto.st',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>,
  },
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/company/crypto-st/',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>,
  },
]

// ─── UPDATED menuSections ──────────────────────────────────────────────────────

const menuSections = [
  {
    title: 'Content',
    links: [
      { label: 'News', href: '/news' },
      { label: 'Crypto terms', href: '/terms' },
      { label: 'Jobs', href: '/jobs' },
    ],
  },
  {
    title: 'Data',
    links: [
      { label: 'Prices', href: '/prices' },
      { label: 'Heatmap', href: '/heatmap' },
      { label: 'Top gainers', href: '/prices/gainers' },
      { label: 'Top losers', href: '/prices/losers' },
      { label: 'Market dominance', href: '/dominance' },
      { label: 'Bitcoin dominance', href: '/dominance/bitcoin' },
    ],
  },
  {
    title: 'Tools',
    links: [
      { label: 'Converter', href: '/prices/bitcoin/converter' },
      { label: 'Predictions', href: '/prices/bitcoin/prediction' },
      { label: 'Price history', href: '/prices/bitcoin/history' },
      { label: 'Exchanges', href: '/prices/bitcoin/exchanges' },
    ],
  },
  {
    title: 'Prop firm',
    links: [
      { label: 'Overview', href: '/prop-firm' },
      { label: 'Start a challenge', href: '/prop-firm#sizes' },
      { label: 'Trader login', href: 'https://trade.crypto.st/en/sign-in', external: true },
    ],
  },
]

// ─── UPDATED AccordionSection ──────────────────────────────────────────────────

function AccordionSection({ title, links }: { title: string; links: { label: string; href: string; external?: boolean }[] }) {
  const [open, setOpen] = useState(false)
  return (
    <div className="border-b border-zinc-800">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between py-3"
      >
        <span className={`text-lg font-[family-name:var(--font-saira)] transition-colors ${open ? 'text-green-500 font-bold' : 'text-white'}`}>
  {title}
</span>
        <span className="text-zinc-500 transition-transform duration-300" style={{ display: 'inline-block', transform: open ? 'rotate(180deg)' : 'rotate(0deg)' }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M6 9l6 6 6-6"/>
          </svg>
        </span>
      </button>
      {open && (
        <ul className="pb-4 space-y-3 pl-1">
          {links.map((link) => (
            <li key={link.href}>
              <Link
                href={link.href}
                {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                className="text-zinc-400 hover:text-green-500 transition-colors text-sm font-[family-name:var(--font-saira)]"
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default function Footer() {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!email) return

    setLoading(true)
    setError('')

    try {
      const res = await fetch('/api/newsletter', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      })

      if (!res.ok) throw new Error()
      setSubmitted(true)
    } catch {
      setError('Something went wrong — try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <footer className="bg-black text-gray-400 border-t border-zinc-800">

      {/* Top section — logo + newsletter */}
      <div className="max-w-7xl mx-auto px-4 py-12 flex flex-col-reverse lg:flex-row gap-12 lg:gap-20 border-b border-zinc-800">

        {/* Left — logo + slogan + socials */}
        <div className="flex-1">
          <Image src={logo} alt="Crypto Street" width={180} height={44} className="mb-4 h-auto" />
          <p className="text-sm text-gray-400 mb-6">Always open, always moving.</p>
          <div className="flex items-center gap-5">
            {socials.map((s) => (
              <a key={s.name} href={s.href} target="_blank" rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors" title={s.name}>
                {s.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Right — newsletter */}
        <div className="flex-1 lg:max-w-md">
          <h3 className="text-white text-2xl font-bold font-[family-name:var(--font-saira)] mb-2">
            Crypto Street Insider
          </h3>
          <p className="text-gray-400 text-sm mb-5">
            Profitable crypto insights you won't find elsewhere
          </p>
          {submitted ? (
            <p className="text-[#25B362] text-sm font-semibold">You're in - welcome to the street.</p>
          ) : (
            <>
              <form onSubmit={handleSubmit} className="flex gap-0">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                  disabled={loading}
                  className="flex-1 bg-zinc-900 border border-zinc-700 text-white text-sm px-4 py-3 outline-none focus:border-zinc-500 placeholder:text-zinc-600 disabled:opacity-50"
                />
                <button
                  type="submit"
                  disabled={loading}
                  className="bg-white text-black text-sm font-semibold px-5 py-3 hover:bg-green-500 hover:text-black transition-all duration-300 font-[family-name:var(--font-saira)] uppercase tracking-widest whitespace-nowrap disabled:opacity-50"
                >
                  {loading ? 'Sending...' : 'Subscribe'}
                </button>
              </form>
              <div className="flex items-center justify-between mt-2">
                <p className="text-zinc-400 text-xs">~4 emails per month. No spam.</p>
                <p className="text-zinc-400 text-xs">Join 33,000+ subscribers</p>
              </div>
              {error && <p className="text-red-400 text-xs mt-2">{error}</p>}
            </>
          )}
        </div>
      </div>

      {/* Bottom section — menu columns desktop / accordion mobile */}
      <div className="max-w-7xl mx-auto px-4 py-10">

        {/* Desktop columns — UPDATED: 4 cols, small uppercase section titles, green hover */}
        <div className="hidden md:grid grid-cols-4 gap-8">
          {menuSections.map((section) => (
            <div key={section.title}>
              <h3 className="text-white font-semibold text-base font-[family-name:var(--font-saira)] mb-4">
                {section.title}
              </h3>
              <ul className="space-y-2.5 text-sm">
                {section.links.map((link) => (
                  <li key={link.href}>
                    <Link
                      href={link.href}
                      {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                      className="text-zinc-400 hover:text-green-500 transition-colors text-sm font-[family-name:var(--font-saira)]"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Mobile accordion */}
        <div className="md:hidden">
          {menuSections.map((section) => (
            <AccordionSection key={section.title} title={section.title} links={section.links} />
          ))}
        </div>
      </div>

      {/* Copyright */}
      <div className="max-w-7xl mx-auto px-4 py-12 border-t border-zinc-900 text-xs text-zinc-400">
        © {new Date().getFullYear()} crypto.st — All rights reserved.
      </div>

      {/* Disclaimer */}
      <div className="border-t border-zinc-900">
        <div className="max-w-7xl mx-auto px-4 py-10 space-y-6">

          <div>
            <p className="text-xs uppercase tracking-[0.1em] text-zinc-400 mb-2">Risk disclosure</p>
            <p className="text-xs text-zinc-400 leading-relaxed">
              Trading cryptocurrencies involves substantial risk of loss and is not suitable for all investors. Past performance is not indicative of future results. You should carefully consider whether trading is appropriate for you in light of your experience, objectives, financial resources, and other relevant circumstances.
            </p>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.1em] text-zinc-400 mb-2">Geographic restrictions</p>
            <p className="text-xs text-zinc-400 leading-relaxed">
              Crypto Street does not provide services to residents of countries subject to OFAC sanctions or other jurisdictions where our services are restricted by law. This includes but is not limited to: Cuba, Iran, North Korea, Syria, and the Crimea region of Ukraine. By using our services, you represent that you are not located in, under the control of, or a national or resident of any restricted jurisdiction.
            </p>
          </div>

          <div>
            <p className="text-xs text-zinc-400 leading-relaxed">
              Crypto Street is an affiliate of Prop Account, LLC. All funding assessments are provided by Prop Account, LLC and all assessment fees are paid to Prop Account, LLC. If you qualify for a Funded Account, you will be required to enter into a Trader Agreement with Prop Account LC. Neither Prop Account, LLC nor Prop Account LC provides any trading education or other services. All such services are provided by Crypto Street.
            </p>
          </div>

          <div>
            <a href="https://dashboardanalytix.com/client-terms-and-policies/?v=3acf83834396"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-zinc-400 hover:text-zinc-300 underline underline-offset-2 transition-colors"
            >
              Prop trading terms and conditions →
            </a>
          </div>

        </div>
      </div>
    </footer>
  )
}